import React, { useState } from 'react';
import SurgicalFacilitiesDashboard from './SurgicalFacilitiesDashboard';
import OperatingRoomManagement from './OperatingRoomManagement';
import SurgicalTeamManagement from './SurgicalTeamManagement';
import SurgicalEquipmentManagement from './SurgicalEquipmentManagement';
import SurgicalProcedureMapping from './SurgicalProcedureMapping';
import SurgicalSchedule from './SurgicalSchedule';
import SurgicalReports from './SurgicalReports';
import SurgicalCaseWorkQ from './SurgicalCaseWorkQ';
import { Box, Tabs, Tab, Paper, Typography, Container, Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import { 
  Dashboard as DashboardIcon,
  MeetingRoom as RoomIcon,
  Group as TeamIcon,
  Build as EquipmentIcon,
  Map as MappingIcon,
  CalendarToday as ScheduleIcon,
  Assessment as ReportsIcon,
  Assignment as WorkQIcon
} from '@mui/icons-material';

// Styled Components - Purple/Blue Gradient Header
const HeaderCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  marginBottom: theme.spacing(1.5),
  borderRadius: '8px',
  boxShadow: '0 4px 16px rgba(102, 126, 234, 0.2)',
}));

const SurgicalFacilities = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabs = [
    { label: 'Dashboard', icon: <DashboardIcon />, component: <SurgicalFacilitiesDashboard /> },
    { label: 'Operating Rooms', icon: <RoomIcon />, component: <OperatingRoomManagement /> },
    { label: 'Surgical Teams', icon: <TeamIcon />, component: <SurgicalTeamManagement /> },
    { label: 'Equipment', icon: <EquipmentIcon />, component: <SurgicalEquipmentManagement /> },
    { label: 'Surgical Procedure Mapping', icon: <MappingIcon />, component: <SurgicalProcedureMapping /> },
    { label: 'Schedule', icon: <ScheduleIcon />, component: <SurgicalSchedule /> },
    { label: 'Surgical Case WorkQ', icon: <WorkQIcon />, component: <SurgicalCaseWorkQ /> },
    { label: 'Reports', icon: <ReportsIcon />, component: <SurgicalReports /> },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Header Card with Purple/Blue Gradient */}
      <HeaderCard>
        <CardContent sx={{ py: 1.5, px: 3, '&:last-child': { pb: 1.5 } }}>
          <Box display="flex" alignItems="center" gap={2}>
            <RoomIcon sx={{ fontSize: 24 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>
                Surgical Facilities Management
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', mt: 0.5 }}>
                Comprehensive management system for surgical facilities, operating rooms, teams, and equipment
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </HeaderCard>

      <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#f8f9fa' }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTab-root': {
                minHeight: 64,
                fontSize: '0.9rem',
                fontWeight: 500,
                textTransform: 'none',
                color: '#6c757d',
                '&.Mui-selected': {
                  color: '#708bff',
                  fontWeight: 600,
                },
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#708bff',
                height: 3,
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {tab.icon}
                    {tab.label}
                  </Box>
                }
              />
            ))}
          </Tabs>
        </Box>
        
        <Box sx={{ p: 3, minHeight: '600px' }}>
          {tabs[activeTab].component}
        </Box>
      </Paper>
    </Container>
  );
};

export default SurgicalFacilities; 